module.exports = __webpack_public_path__ + "static/img/payway3.b1fe506.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/payway3.png
// module id = 0yU0
// module chunks = 1